import React, { useState, useEffect } from 'react';

import { assertions, regex } from 'lib/assertions';
import BoxBody from 'components/BoxBody';
import Dialog from 'components/Dialog';
import Button from 'components/Button';
import FormElement from 'components/FormElement';
import Input from 'components/Input';
import Text from 'components/Text';
import Row from 'components/Row';

import { isEmpty } from 'lodash';

const emailRegexp = new RegExp(regex.email);

export type ContactInfoDialogProps = {
  name: string;
  currentDevices: string[];
  loading?: boolean;
  onRequestHide: () => void;
  onComplete: (phoneOrEmail: string) => void;
  deviceUuid?: string;
  deviceUid?: string;
};

const ContactInfoDialog = ({
  name,
  currentDevices,
  loading,
  onRequestHide,
  onComplete,
  deviceUuid,
  deviceUid,
}: ContactInfoDialogProps): JSX.Element => {
  const isEditing:boolean = !isEmpty(deviceUuid) && !isEmpty(deviceUid);
  const [value, setValue] = useState<string | undefined>();
  const deviceRepeated = currentDevices.find(device => value === device);
  const deviceType = value && emailRegexp.test(value) ? 'email address' : 'phone number';

  const action = (isEditing ? 'Edit': 'Add');
  const title = action + ' contact information';
  useEffect(() => {
    if (isEditing) {
      setValue(deviceUid);
    }
  }, [deviceUid]);

  return (
    <Dialog title={title} size="xsmall" onRequestHide={onRequestHide}>
      <BoxBody>
        <form
          data-test="contact-info-form"
          onSubmit={e => {
            e.preventDefault();
            if (value) {
              onComplete(value);
            }
          }}>
          <FormElement
            data-test="username"
            label={action + " phone or email"}
            onValidChange={e => setValue(e.target.value)}
            onInvalidChange={() => setValue(undefined)}
            manualError={deviceRepeated && value !== deviceUid ? `This person already has this ${deviceType}` : null}
            validate={e => {
              assertions.emailOrPlausibleNorthAmericanPhoneNumber(
                e.target.value,
                'Invalid email address or phone number'
              );
            }}
            element={Input}
            elementProps={{
              autocomplete: 'username',
              name: 'username',
              type: 'username',
              placeholder: 'Phone or email',
              size: 'large',
              required: true,
              value: value
            }}
          />

          <Row size="medium">
            <Text color="graphite" size="xsmall" align="left">
              {name} will be notified.
            </Text>
          </Row>

          <Button
            data-test="submit-button"
            eventElementName="ContactInfoDialog-submit"
            type="submit"
            level="primary"
            color="mascot"
            full
            loading={loading}
            disabled={!value || Boolean(deviceRepeated)}>
            { isEditing ? 'Save' : 'Add' }
          </Button>
        </form>
      </BoxBody>
    </Dialog>
  );
};

export default ContactInfoDialog;
